<div [class.form-row]="formRow()" [formGroup]="childForm">
  @if (!addressWithoutDARValidation()) {
    <mat-form-field [class.full-width]="!formRow()" [hideRequiredMarker]="hideRequiredMarker()">
      <mat-label>{{ label() }}</mat-label>
      <input type="text" placeholder="Påbegynd indtastning" matInput [matAutocomplete]="auto" formControlName="addressLookup" />
      @if (childForm.controls.addressLookup.hasError('required') || childForm.controls.addressLookup.hasError('addressNotSelected')) {
        <mat-error> Adresse er påkrævet. </mat-error>
      }
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayAddress"
        (optionSelected)="addressChanged($event.option.value)"
        okCustomDropDownArrowDirective>
        @for (address of filteredAddresses(); track address.darId) {
          <mat-option [value]="address">
            {{ addressService.formatAddressToString(address) }}
          </mat-option>
        }
      </mat-autocomplete>
      <mat-icon matSuffix></mat-icon>
      @if (loading()) {
        <ok-form-field-loading />
      }
    </mat-form-field>
  } @else {
    <mat-form-field>
      <mat-label>Adresse</mat-label>
      <input type="text" placeholder="Adresse" matInput formControlName="addressWithoutValidation" />
      @if (childForm.controls.addressWithoutValidation.hasError('required')) {
        <mat-error>Adresse er påkrævet</mat-error>
      }
    </mat-form-field>
  }
</div>
